var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2"},[_c('div',{staticClass:"se-table__above"},[_vm._t("above")],2),_vm._v(" "),_c('div',{staticClass:"se-table",class:'se-table--' + _vm.columns},[_vm._t("default")],2)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9bb924a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = null
// module chunks = 